export const BUSINESS_TRAVELLER_ROLES = {
  BUSINESS_ADMIN: 'Admin',
  BUSINESS_APPROVER: 'Approver',
  BUSINESS_MANAGER: 'Manager',
  BUSINESS_EMPLOYEE: 'Employee',
} as const;

export const BUSINESS_TRAVELLER_ROLE_KEYS = {
  ADMIN: 'BUSINESS_ADMIN',
  APPROVER: 'BUSINESS_APPROVER',
  MANAGER: 'BUSINESS_MANAGER',
  EMPLOYEE: 'BUSINESS_EMPLOYEE',
} as const;

export const hasBusinessAdminOrManagerRole = (roles: Array<string>): boolean => {
  return roles.some(
    (role) => role === BUSINESS_TRAVELLER_ROLE_KEYS.ADMIN || role === BUSINESS_TRAVELLER_ROLE_KEYS.MANAGER,
  );
};
